import axios from 'axios';
import env from '../env/env.js'


export async function IniciarSesion(txtEmail, txtContrasena) {
    try {
        const response = await axios.post(env.getDomain() + 'escoba_sesion', {
            txtEmail: txtEmail,
            txtContrasena: txtContrasena
        });

        return response.data;

    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}
export async function Registra(txtNombre, txtApellidos, txtEmail, txtContrasena) {
    try {
        const response = await axios.post(env.getDomain() + 'escoba_registro', {
            txtNombre: txtNombre,
            txtApellidos: txtApellidos,
            txtEmail: txtEmail,
            txtContrasena: txtContrasena
        });
        return response.data;
    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}

export async function Recupera(txtEmail, txtContrasena) {
    try {
        const response = await axios.post(env.getDomain() + 'escoba_recuperacion', {
            txtEmail: txtEmail,
            txtContrasena: txtContrasena
           
        });
        return response.data;
    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}

export async function DatosUsuario(txtEmail) {
    try {
        const response = await axios.post(env.getDomain() + 'escoba_puntosU', {
            txtEmail: txtEmail
        });

        return response.data;

    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}

export async function getCopa() {
    try {
        const response = await axios.get(env.getDomain() + 'getPuntos', {

        });

        return response.data;

    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}

export async function getApi(api) {
    try {
        const response = await axios.get(env.getDomain() + api, {

        });

        return response.data;

    } catch (error) {
        return { error: true, message: error.message };
    }
}




